var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bottomRight"}},[_c('div',{staticClass:"bg-color-black"},[_c('div',[_c('centerRight1')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }